import React, { useState } from "react";
import "./moduleList.scss";

const ModuleList = () => {
  const [modulesData] = useState([
    {
      title: "Instalacja i konfiguracja wstępna",
      lessons: [
        "Wprowadzenie do kursu",
        "Instalacja Proxmox",
        "Instalcja Proxmox Backup",
        "Instalacja Windows Serwer 2022 na Proxmox",
        "Wstępna Konfiguracja Windows Serwer z Proxmox",
        "Instalacja Active Directory",
        "Podłączenie komputera do domeny Win10/Win11",
        "Instalacja TrueNas",
        "Instalacja MailCow",
      ],
    },
    {
      title: "Windows Serwer",
      lessons: [
        "Wstępna Konfiguracja Active Directory",
        "Przygotowanie szkieletu",
        "Tworzenie Użytkowników",
        "Przekierowanie Folderów",
        "Pliki trybu offline",
      ],
    },
    {
      title: "Bezpieczeństwo",
      lessons: [
        "Kopia zapasowa",
        "TrueNas jako dodatkowe miejsce na kopię zapasową",
        "Konfiguracja kopii zapasowej Windows Serwer na TrueNas",
        "UrBackup jako dodatkowy program do kopii zapasowych",
        "Dobre praktyki co do kopii zapasowych, zasada 3-2-1",
        "Odzyskiwanie dysku na TrueNas",
      ],
    },
    {
      title: "MailCow",
      lessons: [
        "Instalacja oraz konfiguracja domeny",
        "Dodawanie domeny do serwera pocztowego",
        "Stworzenie pierwszego konta pocztowego",
        "Konfiguracja Outlooka + Certyfikat",
        "Konfiguracja Thunderbird + Certyfikat",
        "Kopie zapasowe serwera pocztowego",
        "Przenoszenie poczty z hostingu na własny serwer pocztowy",
      ],
    },
    {
      title: "MikroTik",
      lessons: [
        "Konfiguracja OpenVPN",
        "Konfiguracja WireGuard",
        "Konfiguracja PortKnocking (VPN, MikroTik)",
        "Kopia zapasowa MikroTik",
        "Ciekawe Skrypty",
      ],
    },
  ]);
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  return (
    <div className="module-list">
      <h2>Czego dokładnie możesz się spodziewać?</h2>
      <p>Kliknij dowolną sekcję, aby zobaczyć, co znajdziesz w środku.​</p>
      <div className="space-y-4">
        {modulesData.map((module, index) => (
          <div
            key={index}
            className="module"
            onClick={() => toggleModule(index)}
          >
            <div className="module-header">
              <span className="title">{module.title}</span>
              <span className="toggle-icon">
                {openModule === index ? "▲" : "▼"}
              </span>
            </div>
            {openModule === index && (
              <div className="module-content">
                <ul>
                  {module.lessons.map((lesson, lessonIndex) => (
                    <li key={lessonIndex}>
                      {`Lekcja ${lessonIndex + 1}: ${lesson}`}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModuleList;
